<template>
  <div style="max-width: 470px; margin: auto">
    <div class="templateDivBlockPage">
      <div class="TopTemplateDivBlockPage">
        <img src="/app/img/block.png" alt="block.png">
        <h3>کاربری شما مسدود میباشد</h3>
        <h4>راننده گرامی حساب شما مسدود میباشد</h4>
      </div>

      <div class="ButtonCloseApp">
        بستن برنامه
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "BlockPage"
}
</script>

<style scoped>
.templateDivBlockPage{
  margin: 30% auto;
  width: 90%;
  height: 400px;
}

.TopTemplateDivBlockPage{
  height: 250px;
  background: #FABD4A;
  border-radius: 10px;
  text-align: center;
  padding-top: 10px;
}
.TopTemplateDivBlockPage h3{
}
.TopTemplateDivBlockPage h4{
  font-size: .95rem;
}

.TopTemplateDivBlockPage img{
  margin: 0 auto;
  text-align: center;
  width: 145px;
  height: 150px;
  margin-bottom: 10px;
}

.ButtonCloseApp{
  height: 50px;
  border-radius: 10px;
  background: #FF0000;
  text-align: center;
  line-height: 50px;
  margin-top: 30px !important;
  color: white;
  margin-top: 10px;
  cursor: pointer;
}
</style>